import React from "react";
import {EmployeeSigning} from "./employeeSigning";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const SigningPage = () => <ConsentDocumentsLayout><EmployeeSigning/></ConsentDocumentsLayout>;
